import type { Messages } from "@prop/i18n";
import type en from "../en/support";

export default {
  nav: "Ayuda",
  title: "Ayuda y soporte",
  lead: "Busca primero en las respuestas. Si no encuentras la tuya, escríbenos y la respuesta llegará aquí.",
  search: "Buscar respuestas",
  searchPlaceholder: "p. ej. pérdida diaria, payout, ejecución",
  noAnswers: "No hay respuestas que coincidan. Prueba con otras palabras o pregúntanos abajo.",
  notFound: "¿No encontraste tu respuesta?",
  contact: "Contactar con soporte",
  categories: { account: "Cuenta y reglas", trading: "Trading y ejecuciones", payments: "Pagos y payouts", kyc: "Verificación de identidad", technical: "Problema técnico", other: "Otra cosa" },
  form: {
    title: "Nueva solicitud",
    category: "Tema",
    pickTopic: "Elige un tema",
    account: "Cuenta (opcional)",
    noAccount: "No es sobre una cuenta concreta",
    subject: "Asunto",
    subjectHint: "Una línea, p. ej. «Orden ejecutada a otro precio»",
    body: "¿Qué pasó?",
    bodyHint: "Indica la hora, el instrumento y lo que esperabas. Una solicitud por problema.",
    send: "Enviar solicitud",
    cancel: "Cancelar",
  },
  my: "Mis solicitudes",
  none: "Todavía no tienes solicitudes.",
  status: { open: "Esperando a soporte", pending_staff: "Esperando a soporte", pending_user: "Esperando tu respuesta", resolved: "Resuelta", closed: "Cerrada" },
  thread: {
    back: "Todas las solicitudes",
    you: "Tú",
    support: "Soporte",
    reply: "Tu respuesta",
    send: "Enviar",
    close: "Cerrar solicitud",
    closed: "Esta solicitud está cerrada. Abre una nueva si necesitas más ayuda.",
    resolvedHint: "Creemos que esto está resuelto. Si no es así, responde y la solicitud se reabre.",
  },
  admin: {
    tab: "Soporte",
    views: { queue: "Cola", kb: "Base de conocimiento", templates: "Plantillas" },
    filter: { active: "Nos toca", waiting: "Esperando al cliente", resolved: "Resueltas", closed: "Cerradas", all: "Todas" },
    anyCategory: "Cualquier tema",
    anyone: "Cualquiera",
    mine: "Asignadas a mí",
    unassigned: "Sin asignar",
    empty: "No hay nada. La cola está vacía.",
    ticket: "Solicitud",
    topic: "Tema",
    statusCol: "Estado",
    priorityCol: "Prioridad",
    due: "Primera respuesta antes de",
    overdue: "vencida",
    assignee: "Responsable",
    status: { open: "Nueva", pending_staff: "El cliente respondió", pending_user: "Esperando al cliente", resolved: "Resuelta", closed: "Cerrada" },
    priority: { low: "Baja", normal: "Normal", high: "Alta", urgent: "Urgente" },
    pick: "Elige una solicitud de la cola.",
    account: "Cuenta",
    language: "Idioma",
    internal: "Nota interna",
    template: "Insertar plantilla",
    message: "Mensaje",
    noteMode: "Nota interna (el cliente no la ve)",
    andResolve: "Marcar como resuelta",
    sendReply: "Enviar respuesta",
    addNote: "Añadir nota",
    kb: {
      new: "Nuevo artículo",
      slug: "Slug (igual en todos los idiomas)",
      locale: "Idioma",
      category: "Tema",
      title: "Título",
      body: "Texto",
      sort: "Orden",
      published: "Publicado",
      draft: "Borrador",
      save: "Guardar",
      delete: "Eliminar",
      saved: "Guardado.",
      confirmDelete: "¿Eliminar definitivamente?",
    },
    tpl: {
      new: "Nueva plantilla",
      title: "Título",
      body: "Texto ({name} se reemplaza por el nombre del cliente)",
      category: "Tema",
      anyTopic: "Cualquier tema",
      locale: "Idioma",
    },
  },
} satisfies Messages<typeof en>;
